<template>
  <div
    class="custom-select-plates-dropdown-content"
  >
    <div class="custom-select-plates-dropdown-content__options-wrap">
      <size
        class="custom-select-plates-dropdown-content__option"
        :key="option.value"
        v-for="option in options"
        :title="option.label"
        :is-selected="isSelected(option)"
        :is-out-of-stock="option.count === 0"
        @click.native="toggle(option)"
      />
    </div>
  </div>
</template>

<script>
import Size from '@kit/size/size.vue';

export default {
  name: "custom-select-plates-dropdown-content",

  components: {
    Size
  },

  props: {
    options: {
      type: Array,
      default: () => []
    },
    selectedOptions: {
      type: Array,
      default: () => []
    },
  },

  methods: {
    isSelected(option) {
      return this.selectedOptions.some(({ value }) => value === option.value);
    },
    toggle(option) {
      const event = this.isSelected(option)? 'remove' : 'add';

      this.$emit(event, option);
    },
  },
}
</script>

<style lang="scss">
  .custom-select-plates-dropdown-content {
    min-width: 240px;

    &__options-wrap {
      display: flex;
      flex-wrap: wrap;
      margin: 20px 4px 12px 12px;
    }

    &__option {
      margin-right: 8px;
      margin-bottom: 8px;
    }
  }
</style>